import { Component, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { SoftCloseService } from 'app/components/compensation/softclose/softclose.service';

@Component({
  selector: 'app-metric-link-renderer',
  templateUrl: './metric-link-renderer.component.html',
  styleUrls: ['./metric-link-renderer.component.scss']
})
export class MetricLinkRendererComponent implements ICellRendererAngularComp {
  public params: any;
  public processingTime!: number;

  constructor(private softCloseService: SoftCloseService) {}

  public agInit(params: any): void {
    this.params = params;
    const convertFn = params.convertToMinutes;
    this.processingTime = convertFn(params);
  }

  public refresh(): boolean {
    return false;
  }

  public onClick(event: Event) {
    event.preventDefault();
    this.softCloseService.triggerMetricModal(this.params.data);
  }
}
